import type { AiModelEnum, Annotation, EvidenceSessionAIModel } from 'api';
import { Box, Divider, FormControlLabel, FormGroup, Stack, Switch, Typography, useBreakpoint } from 'ui';

import { SegmentationLegend } from '../../../quality-report/components/SegmentationLegend/SegmentationLegend';

export const AiFilters = ({
  selectedAnnotation,
  hiddenCategories,
  handleHideCategory,
  handleToggleLegend,
  showLegend,
  showSwitch,
  model,
  showAerosols = false,
}: {
  selectedAnnotation: Annotation[];
  hiddenCategories: string[];
  handleHideCategory: (label: string) => void;
  handleToggleLegend: (checked: boolean) => void;
  showLegend: boolean;
  showSwitch: boolean;
  model: AiModelEnum | EvidenceSessionAIModel;
  showAerosols?: boolean;
}) => {
  const { isMobile } = useBreakpoint();
  return (
    <Stack gap={2}>
      {!isMobile ? (
        <>
          <Typography variant="body1" sx={{ paddingX: 4 }}>
            Show or hide the material outlines and compare them to the original photo.
          </Typography>
          <Divider />
        </>
      ) : null}
      {showSwitch ? (
        <FormGroup sx={{ paddingX: isMobile ? 4 : 6 }}>
          <FormControlLabel
            control={
              <Switch
                checked={showLegend}
                onChange={(e) => handleToggleLegend(e.target.checked)}
                size="small"
                data-testid="toggle-segmentation"
              />
            }
            label="Show AI Outlines"
          />
        </FormGroup>
      ) : null}

      <Box sx={{ visibility: showLegend ? 'visible' : 'hidden' }} paddingBottom={1}>
        <SegmentationLegend
          annotations={selectedAnnotation ?? []}
          hiddenCategories={hiddenCategories}
          onSelectCategory={handleHideCategory}
          model={model}
          showAerosols={showAerosols}
        />
      </Box>
    </Stack>
  );
};
